"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiningOperations = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var MiningOperations = (function (_super) {
    __extends(MiningOperations, _super);
    function MiningOperations() {
        return _super.call(this, {
            name: CardName_1.CardName.MINING_OPERATIONS,
            tags: [Tags_1.Tags.BUILDING],
            productionBox: Units_1.Units.of({ steel: 2 }),
            metadata: {
                cardNumber: 'P21',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.steel(2); }).br;
                    b.steel(4);
                }),
                description: 'Increase your steel production 2 steps. Gain 4 steel.',
            },
        }) || this;
    }
    MiningOperations.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.STEEL, 2);
        player.steel += 4;
        return undefined;
    };
    return MiningOperations;
}(PreludeCard_1.PreludeCard));
exports.MiningOperations = MiningOperations;
//# sourceMappingURL=MiningOperations.js.map